/* Collapsible content: Hide empty metafields */

document.addEventListener('DOMContentLoaded', () => {

    // Hide Accordion when metafield is empty
    const accordions = document.querySelectorAll('collapsible-row');

    accordions.forEach((accordion) => {
        const content = accordion.querySelector('.collapsible__content');
        if (!content || content.innerHTML.trim() === '') {
            accordion.style.display = 'none';
        }
    });
});